module.exports = __webpack_public_path__ + "static/media/familia-madevia.677dcf38.webp";